<template>
  <div class="timeline" :style="`--partner-dot-color: ${$partnerACL.getBackgroundColorApp()}`">
    <div class="timeline-item d-flex flex-column">
      <span class="f-s-xs">{{ route.origin }}</span>
      <span class="f-bold f-s-xs" style="line-height: 1.2;">{{ route.long_origin }}</span>
    </div>
    <div class="timeline-item d-flex flex-column">
      <span class="f-s-xs">{{ route.destination }}</span>
      <span class="f-bold f-s-xs" style="line-height: 1.2;">{{ route.long_destination }}</span>
    </div>
  </div>
</template>

<script>
export default {
    name: "TimelineDashed",
    props: {
        route: {
            type: Object,
            default: () => ({
                origin: "",
                long_origin: "",
                destination: "",
                long_destination: ""
            }) 
        }
    }
}
</script>

<style lang="scss" scoped>
.timeline {
    position: relative;
    padding-left: 16px;
}

.timeline-item {
    position: relative;
    padding-left: 8px;
    height: 50px;
    /* Jarak antar item */
}

.timeline-item:last-child {
    margin-bottom: 0;
}

.timeline-item::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 4px;
    width: 12px;
    height: 12px;
    background-color: var(--partner-dot-color);
    border-radius: 50%;
}

.timeline-item::after {
    content: "";
    position: absolute;
    left: -5px;
    top: 16px;
    width: 2px;
    height: 50px;
    border-left: 2px dashed #aaa;
}

/* Hapus garis pada item terakhir */
.timeline-item:last-child::after {
    display: none;
}
</style>